import jwtDecode from 'jwt-decode';

/**
 * Tokens issued by NuxNode's first-party GraphQL backend stamp ``owner=saleor``
 * for parity with the Saleor schema, but legacy tokens — and any tokens issued
 * by an older version of the API — may omit the claim entirely.  We treat an
 * absent / empty ``owner`` as internal so the SDK falls back to the
 * ``tokenRefresh`` mutation (which the backend implements) instead of the
 * ``externalRefresh`` plugin path (which doesn't), avoiding a spurious logout
 * on the next page reload.  Any other non-empty value is still routed through
 * the external-plugin code path.
 */
export const isInternalToken = (owner: string | null | undefined): boolean =>
  !owner || owner === 'saleor';

export const isLikelyJwt = (value: unknown): value is string =>
  typeof value === 'string' && value.length > 0 && value.split('.').length === 3;

export function safeJwtDecode<T>(token: string | null | undefined): T | null {
  if (!token || typeof token !== 'string') {
    return null;
  }

  try {
    return jwtDecode<T>(token);
  } catch {
    console.warn('[saleor-sdk] Failed to decode JWT token; auth state will be reset.');

    return null;
  }
}
